import type React from 'react';

// Figma design tokens for the blocked-crawler tag (AI Insights).
// The dashboard theme has no Tag error override and its colorError (#db232d) differs
// from the design system, so the antd "error" preset would not match the design.
// The exact design-system error values are pinned here:
// status/error/color-error, components/tag/global/color-error-bg, color-error-border.
export const blockedCrawlerTagStyle: React.CSSProperties = {
  color: '#eb6757',
  backgroundColor: '#ffede9',
  borderColor: '#fbb6aa',
};
